import React, { FC } from 'react'
import { LabelProps, TagProps, TagListProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { useRouter } from 'next/router'
import { isFontelloIcon } from '@sport1/news-styleguide/FontelloHelpers'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'
import WrappedNavigationListItem from '../WrappedNavigationListItem'
import nofollowExternal from '@/utils/url/nofollowExternal'

type Props = Pick<TagListProps, 'headline' | 'content'> & {
    bold?: boolean
    onTagPress?: (tag: TagProps | LabelProps) => void
}

const TagList: FC<Props> = ({ headline, content, onTagPress }) => {
    const { asPath } = useRouter()
    return (
        <NonFlexingContainer>
            {headline ? (
                <NonFlexingContainer paddingX="spacing-6" paddingBottom="spacing-6">
                    <CardHeadline cardHeadlineType="cardHeadlineXS" text={headline} />
                </NonFlexingContainer>
            ) : null}

            {content.map((tag, index) => {
                const href = tag.href || ''
                return (
                    <WrappedNavigationListItem
                        key={`${tag.id || tag.contextId}_${index}`}
                        testID={`tag-list-navigation-item-${tag.title}`}
                        title={tag.title}
                        value={tag.childrenCount}
                        leadingType={
                            tag.iconName && isFontelloIcon(tag.iconName) ? 'icon' : 'image'
                        }
                        leading={
                            tag.iconName && isFontelloIcon(tag.iconName)
                                ? tag.iconName
                                : tag.iconUrl
                        }
                        alt={tag.title}
                        backgroundColor={href === asPath ? 'onyx-opacity-12' : 'pearl'}
                        trailingIcon="arrow_forward_ios"
                        trailingIconColor="keshi-3"
                        href={href}
                        onPress={onTagPress ? () => onTagPress(tag) : undefined}
                        webRel={nofollowExternal}
                        webTarget={tag.hrefTarget}
                        marginTop={index > 0 ? 'spacing-1' : undefined}
                    />
                )
            })}
        </NonFlexingContainer>
    )
}

export default TagList
